import type { FaireProductEntity } from "../../entity_types/product";

export const p_7rc37fu6kb: FaireProductEntity = {
  token: "p_7rc37fu6kb",
  type: "product",
  name: 'Mini Tumbled Clear Quartz Crystals - 36 pcs, .5"',
  brandToken: "b_23c7bc37",
  brandName: "GeoCentral",
  imageUrl:
    "https://cdn.faire.com/fastly/eb1ed2f0006fbd648371a41a0b9f0decaf123eb27d24209392764b9f97d4c118.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/88454fa5670ff25bcc8d49f10f94a748889872f2b1651b734f3970eecda660b4.jpeg",
  ],
  priceDollars: 0.42,
  description:
    "- Clear quartz is amplifying + clearing \n- Our assortment of mini crystals are .5” And perfect for carrying in a small bag, keeping in a pocket, or crystal grid making. \n- You will find that the variety and quality of our crystals transform one-item customers into multiple-item collectors! \n- For add-on sales, supplement this new product with bags, crystal grids, and loose tools.\n\nWholesale Crystals | Crystals for Beginners | Introductory Crystals | Souvenir Crystals | Educational Crystals | Geological | Metaphysical | Crystal Properties",
  tags: [],
  msrpDollars: 0.83,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:55:40.102Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
